(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["liveshop"] && !Shopify.designMode) return;
  try {
    
  class LiveShopSection extends HTMLElement {
    connectedCallback() {
      this.products = this.querySelector('[data-live-shop-products]');
      this.announcements = this.querySelector('[data-live-shop-announcements]');
      this.nowPlaying = this.querySelector('[data-live-shop-now]');
      this.searchInput = this.querySelector('[data-live-shop-search]');
      this.sectionId = this.dataset.sectionId;
      this.pollInterval = Number(this.dataset.pollInterval) || 10000;
      this.loading = false;
      this.catalog = null;

      this.loadMore = this.querySelector('[data-live-shop-load-more]');
      this.sentinel = this.querySelector('[data-live-shop-sentinel]');

      if (this.loadMore) {
        this.loadMore.addEventListener('click', (event) => {
          event.preventDefault();
          this.loadNextPage();
        });
      }

      if (this.sentinel && this.products) {
        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries[0].isIntersecting) this.loadNextPage();
          },
          { root: this.products, rootMargin: '120px' }
        );
        this.observer.observe(this.sentinel);
      }

      if (this.searchInput) {
        this.searchInput.addEventListener('input', () => {
          clearTimeout(this.searchTimer);
          this.searchTimer = setTimeout(() => this.filterProducts(), 200);
        });
      }

      if (!window.Shopify?.designMode) {
        this.pollTimer = setInterval(() => this.refreshLiveContent(), this.pollInterval);
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.pollTimer) clearInterval(this.pollTimer);
      clearTimeout(this.searchTimer);
    }

    nextPageUrl() {
      return this.querySelector('[data-live-shop-load-more]')?.dataset.url || '';
    }

    titleOf(element) {
      return (element.dataset.title || element.querySelector('.live-shop__product-title')?.textContent || '')
        .trim()
        .toLowerCase();
    }

    matchesQuery(title, query) {
      if (!query) return true;
      const normalized = title.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const needle = query.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      return normalized.includes(needle);
    }

    async filterProducts() {
      const query = (this.searchInput?.value || '').trim().toLowerCase();
      const nowProducts = this.querySelectorAll('[data-live-shop-now] .live-shop__product');
      nowProducts.forEach((product) => {
        product.classList.toggle('is-hidden', !this.matchesQuery(this.titleOf(product), query));
      });

      const cards = this.products?.querySelectorAll('[data-live-shop-product]') || [];
      const loadMore = this.querySelector('[data-live-shop-load-more]');
      const sentinel = this.querySelector('[data-live-shop-sentinel]');

      if (!query) {
        cards.forEach((product) => product.classList.remove('is-hidden'));
        this.products?.querySelectorAll('[data-live-shop-search-result]').forEach((card) => card.remove());
        loadMore?.classList.remove('is-hidden');
        sentinel?.classList.remove('is-hidden');
        this.querySelector('[data-live-shop-search-empty]')?.remove();
        return;
      }

      loadMore?.classList.add('is-hidden');
      sentinel?.classList.add('is-hidden');

      await this.ensureCatalog();
      const catalogMatches = (this.catalog || []).filter((product) =>
        this.matchesQuery(product.title || '', query)
      );
      const visibleHandles = new Set();

      cards.forEach((product) => {
        const match = this.matchesQuery(this.titleOf(product), query);
        product.classList.toggle('is-hidden', !match);
        if (match && product.dataset.handle) visibleHandles.add(product.dataset.handle);
      });

      this.querySelector('[data-live-shop-search-empty]')?.remove();
      if (catalogMatches.length === 0 && ![...cards].some((card) => !card.classList.contains('is-hidden'))) {
        const empty = document.createElement('p');
        empty.className = 'live-shop__empty';
        empty.dataset.liveShopSearchEmpty = '';
        empty.textContent = 'Nenhum produto encontrado.';
        this.products?.append(empty);
      }

      catalogMatches.forEach((product) => {
        if (visibleHandles.has(product.handle)) return;
        const existing = this.products?.querySelector(`[data-handle="${product.handle}"]`);
        if (existing) {
          existing.classList.remove('is-hidden');
          return;
        }
        this.products?.append(this.buildSearchCard(product));
      });
    }

    async ensureCatalog() {
      if (this.catalog || !this.dataset.collectionHandle) return;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(
          `${root}collections/${this.dataset.collectionHandle}/products.json?limit=250`
        );
        if (!response.ok) {
          this.catalog = [];
          return;
        }
        const data = await response.json();
        this.catalog = data.products || [];
      } catch (error) {
        this.catalog = [];
      }
    }

    buildSearchCard(product) {
      const image = product.images?.[0]?.src || product.featured_image || '';
      const price = product.variants?.[0]?.price || '';
      const card = document.createElement('a');
      card.className = 'live-shop__product';
      card.href = `/products/${product.handle}`;
      card.dataset.liveShopProduct = '';
      card.dataset.liveShopSearchResult = '';
      card.dataset.title = product.title || '';
      card.dataset.handle = product.handle || '';
      card.innerHTML = `
        <span class="live-shop__product-media">
          ${image ? `<img class="live-shop__product-image" src="${image}" alt="" width="88" height="88" loading="lazy">` : ''}
        </span>
        <span class="live-shop__product-info">
          <span class="live-shop__product-title"></span>
          <span class="live-shop__product-price"></span>
        </span>
      `;
      card.querySelector('.live-shop__product-title').textContent = product.title || '';
      card.querySelector('.live-shop__product-price').textContent = price;
      return card;
    }

    async loadNextPage() {
      const nextUrl = this.nextPageUrl();
      if (!nextUrl || this.loading) return;
      if ((this.searchInput?.value || '').trim()) return;

      this.loading = true;
      this.setAttribute('aria-busy', 'true');

      try {
        const url = new URL(nextUrl, window.location.href);
        url.searchParams.set('section_id', this.sectionId);
        const response = await fetch(url);
        if (!response.ok) return;

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const incomingProducts = doc.querySelectorAll(
          '[data-live-shop-products] [data-live-shop-product]'
        );
        const loadMore = this.querySelector('[data-live-shop-load-more]');
        const sentinel = this.querySelector('[data-live-shop-sentinel]');

        incomingProducts.forEach((product) => {
          this.products.insertBefore(product, loadMore || sentinel || null);
        });

        const incomingNext = doc.querySelector('[data-live-shop-load-more]');
        if (incomingNext?.dataset.url && loadMore) {
          loadMore.dataset.url = incomingNext.dataset.url;
          loadMore.setAttribute('href', incomingNext.dataset.url);
        } else {
          this.observer?.disconnect();
          loadMore?.remove();
          sentinel?.remove();
        }
      } finally {
        this.loading = false;
        this.removeAttribute('aria-busy');
      }
    }

    async refreshLiveContent() {
      if (!this.sectionId) return;

      try {
        const url = new URL(window.location.href);
        url.searchParams.delete('page');
        url.searchParams.set('section_id', this.sectionId);
        const response = await fetch(url);
        if (!response.ok) return;

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        this.syncHostFrom(doc.querySelector('live-shop-section'));
        this.replaceIfChanged(this.announcements, doc.querySelector('[data-live-shop-announcements]'));
        this.replaceIfChanged(this.nowPlaying, doc.querySelector('[data-live-shop-now]'));
      } catch (error) {
        return;
      }
    }

    syncHostFrom(incoming) {
      if (!incoming) return;

      const nextStyle = incoming.getAttribute('style') || '';
      if (nextStyle !== (this.getAttribute('style') || '')) {
        this.setAttribute('style', nextStyle);
      }

      const nextClass = incoming.getAttribute('class') || '';
      if (nextClass && nextClass !== (this.getAttribute('class') || '')) {
        this.setAttribute('class', nextClass);
      }
    }

    replaceIfChanged(current, incoming) {
      if (!current || !incoming) return;
      if (incoming.innerHTML !== current.innerHTML) {
        current.innerHTML = incoming.innerHTML;
      }
    }
  }

  if (!customElements.get('live-shop-section')) {
    customElements.define('live-shop-section', LiveShopSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stories-pdp"] && !Shopify.designMode) return;
  try {
    
    if (!window.__VideoStoriesMediaManager) {
      window.__VideoStoriesMediaManager = {
        isMounted(container) {
          return container?.dataset.vscMounted === 'true';
        },
        parseSources(container) {
          const raw = container.dataset.vscSources;
          if (!raw) return [];
          try { return JSON.parse(raw); } catch { return []; }
        },
        getPipMediaClass() {
          return 'video-stories-pip__video';
        },
        getModalMediaClass(container) {
          return container.dataset.vscMediaType === 'external_video'
            ? 'video-stories-modal__external-video'
            : 'video-stories-modal__video';
        },
        buildExternalSrc(container, { autoplay = false, muted = true } = {}) {
          const rawSrc = container.dataset.vscExternalSrc;
          if (!rawSrc) return '';
          const host = container.dataset.vscExternalHost;
          const base = rawSrc.startsWith('http') ? rawSrc : `https:${rawSrc}`;
          const url = new URL(base);
          if (host === 'youtube') {
            url.searchParams.set('autoplay', autoplay ? '1' : '0');
            url.searchParams.set('mute', muted ? '1' : '0');
            return url.toString();
          }
          url.searchParams.set('autoplay', autoplay ? '1' : '0');
          url.searchParams.set('muted', muted ? '1' : '0');
          return url.toString();
        },
        ensurePosterLayer(container) {
          if (!container) return null;
          container.style.backgroundImage = '';
          let layer = container.querySelector('.vsc-poster-layer');
          if (!layer) {
            layer = document.createElement('div');
            layer.className = 'vsc-poster-layer';
            layer.setAttribute('aria-hidden', 'true');
            container.prepend(layer);
          }
          const poster = container.dataset.vscPoster;
          if (poster) {
            layer.style.backgroundImage = `url("${poster}")`;
            layer.classList.remove('is-hidden');
          }
          return layer;
        },
        ensureLoading(container) {
          if (!container) return null;
          let loader = container.querySelector('.vsc-media-loading');
          if (!loader) {
            loader = document.createElement('div');
            loader.className = 'vsc-media-loading';
            loader.innerHTML = '<span></span>';
            container.appendChild(loader);
          }
          container.dataset.vscLoading = 'true';
          return loader;
        },
        setMediaReady(container, element) {
          if (!container || container.dataset.vscLoading === 'false') return;
          container.dataset.vscLoading = 'false';
          container.querySelector('.vsc-poster-layer')?.classList.add('is-hidden');
          if (element) element.classList.add('is-ready');
        },
        bindReadyListeners(container, element) {
          if (!container || !element) return;
          const markReady = () => this.setMediaReady(container, element);
          if (element.tagName === 'VIDEO') {
            if (element.readyState >= 3) markReady();
            else {
              element.addEventListener('canplay', markReady, { once: true });
              element.addEventListener('playing', markReady, { once: true });
            }
            setTimeout(markReady, 8000);
          } else if (element.tagName === 'IFRAME') {
            element.addEventListener('load', markReady, { once: true });
            setTimeout(markReady, 8000);
          }
        },
        mountHosted(container, { loop, muted, className }) {
          const sources = this.parseSources(container);
          if (sources.length === 0) return null;
          const video = document.createElement('video');
          video.preload = 'metadata';
          video.playsInline = true;
          video.muted = muted;
          video.defaultMuted = muted;
          if (muted) video.setAttribute('muted', '');
          video.loop = loop;
          video.controls = false;
          className.split(' ').filter(Boolean).forEach((c) => video.classList.add(c));
          sources.forEach((source) => {
            const s = document.createElement('source');
            s.src = source.url;
            s.type = source.mime_type;
            video.appendChild(s);
          });
          container.appendChild(video);
          video.load();
          return video;
        },
        mountExternal(container, { autoplay, muted, className }) {
          const src = this.buildExternalSrc(container, { autoplay, muted });
          if (!src) return null;
          const iframe = document.createElement('iframe');
          iframe.src = src;
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          iframe.setAttribute('frameborder', '0');
          className.split(' ').filter(Boolean).forEach((c) => iframe.classList.add(c));
          container.appendChild(iframe);
          return iframe;
        },
        mount(container, options = {}) {
          if (!container || this.isMounted(container)) return this.getMediaElement(container);
          this.ensurePosterLayer(container);
          this.ensureLoading(container);
          const mediaType = container.dataset.vscMediaType;
          const loop = container.dataset.vscLoop === 'true';
          const { autoplay = false, muted = true, context = 'pip' } = options;
          const className = context === 'modal' ? this.getModalMediaClass(container) : this.getPipMediaClass();
          let element = null;
          if (mediaType === 'video' || mediaType === 'metafield') {
            element = this.mountHosted(container, { loop, muted, className });
          } else if (mediaType === 'external_video') {
            element = this.mountExternal(container, { autoplay, muted, className });
          }
          if (element) {
            container.dataset.vscMounted = 'true';
            this.bindReadyListeners(container, element);
          }
          return element;
        },
        unmount(container) {
          if (!container) return;
          container.querySelector('video')?.remove();
          const iframe = container.querySelector('iframe');
          if (iframe) { iframe.src = 'about:blank'; iframe.remove(); }
          container.querySelector('.vsc-media-loading')?.remove();
          container.dataset.vscMounted = 'false';
          container.dataset.vscLoading = 'false';
          this.restorePoster(container);
        },
        restorePoster(container) {
          if (!container) return;
          container.dataset.vscLoading = 'false';
          this.ensurePosterLayer(container);
          container.querySelector('.vsc-media-loading')?.remove();
        },
        getMediaElement(container) {
          return container?.querySelector('video, iframe') || null;
        },
        pause(container) {
          container?.querySelector('video')?.pause();
        },
        playHosted(container) {
          const video = container?.querySelector('video');
          if (!video) return;
          video.muted = true;
          const tryPlay = () => video.play().catch(() => setTimeout(tryPlay, 300));
          if (video.readyState >= 2) tryPlay();
          else video.addEventListener('canplay', tryPlay, { once: true });
        }
      };
    }

    const VSWMedia = window.__VideoStoriesMediaManager;

    function vswPauseAllPageVideos() {
      document.querySelectorAll('video').forEach((v) => v.pause());
    }

    class VideoStoriesProductWidget {
      constructor(section) {
        this.section = section;
        this.pipContainer = section.querySelector('.video-stories-pip__inner[data-vsc-media]');
        this.autoplayEnabled = section.dataset.videoAutoplay === 'true';
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.suspended = false;
        this.modal = section.querySelector('.video-stories-modal');

        if (this.pipContainer) {
          VSWMedia.restorePoster(this.pipContainer);
          if (this.autoplayEnabled && !this.reducedMotion) this.resumeVisible();
        }

        if (this.modal) {
          this.storiesModal = new VSWProductStoriesModal(section, this);
        }
      }

      resumeVisible() {
        if (this.suspended || !this.pipContainer) return;
        const isExternal = this.pipContainer.dataset.vscMediaType === 'external_video';
        VSWMedia.unmount(this.pipContainer);
        VSWMedia.mount(this.pipContainer, {
          autoplay: isExternal,
          muted: true,
          context: 'pip'
        });
        if (!isExternal) VSWMedia.playHosted(this.pipContainer);
      }

      suspendAll() {
        this.suspended = true;
        if (this.pipContainer) VSWMedia.unmount(this.pipContainer);
      }

      destroy() {
        this.suspended = true;
        if (this.pipContainer) VSWMedia.unmount(this.pipContainer);
        this.storiesModal?.destroy();
      }
    }

    class VSWProductStoriesModal {
      constructor(section, host) {
        this.section = section;
        this.host = host;
        this.modal = section.querySelector('.video-stories-modal');
        this.stories = Array.from(section.querySelectorAll('.video-stories-modal__story'));
        this.progressEl = section.querySelector('[data-story-progress]');
        this.currentIndex = 0;
        this.isMuted = true;
        this.progressRaf = null;
        if (!this.modal || this.stories.length === 0) return;
        this.buildProgress();
        this.bindEvents();
      }

      bindEvents() {
        this.section.querySelectorAll('[data-story-open]').forEach((trigger) => {
          trigger.addEventListener('click', (e) => {
            e.preventDefault();
            this.open(parseInt(trigger.dataset.storyOpen, 10));
          });
        });
        this.modal.querySelectorAll('[data-story-close]').forEach((el) => el.addEventListener('click', () => this.close()));
        this.modal.querySelectorAll('[data-story-prev]').forEach((el) => el.addEventListener('click', () => this.prev()));
        this.modal.querySelectorAll('[data-story-next]').forEach((el) => el.addEventListener('click', () => this.next()));
        this.modal.querySelectorAll('[data-story-mute]').forEach((el) => el.addEventListener('click', () => this.toggleMute()));
        document.addEventListener('keydown', (event) => {
          if (!this.modal.classList.contains('is-open')) return;
          if (event.key === 'Escape') this.close();
          if (event.key === 'ArrowLeft') this.prev();
          if (event.key === 'ArrowRight') this.next();
        });
      }

      buildProgress() {
        if (!this.progressEl) return;
        this.progressEl.innerHTML = '';
        this.stories.forEach(() => {
          const segment = document.createElement('div');
          segment.className = 'video-stories-modal__progress-segment';
          const fill = document.createElement('span');
          fill.className = 'video-stories-modal__progress-fill';
          segment.appendChild(fill);
          this.progressEl.appendChild(segment);
        });
        this.segments = Array.from(this.progressEl.querySelectorAll('.video-stories-modal__progress-segment'));
      }

      getStoryMediaContainer(story) {
        return story?.querySelector('[data-vsc-media]') || null;
      }

      open(index) {
        this.currentIndex = Math.max(0, Math.min(index, this.stories.length - 1));
        this.modal.hidden = false;
        this.modal.classList.add('is-open');
        this.modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('video-stories-modal-open');
        this.host.suspendAll();
        vswPauseAllPageVideos();
        this.syncMuteButtons();
        this.showStory(this.currentIndex);
      }

      close() {
        this.pauseAllStories();
        this.stories.forEach((story) => {
          const c = this.getStoryMediaContainer(story);
          if (c) { VSWMedia.unmount(c); VSWMedia.restorePoster(c); }
        });
        cancelAnimationFrame(this.progressRaf);
        this.modal.classList.remove('is-open');
        this.modal.hidden = true;
        this.modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('video-stories-modal-open');
        this.host.suspended = false;
        this.host.resumeVisible();
      }

      prev() {
        if (this.currentIndex > 0) this.showStory(this.currentIndex - 1);
        else this.close();
      }

      next() {
        if (this.currentIndex < this.stories.length - 1) this.showStory(this.currentIndex + 1);
        else this.close();
      }

      showStory(index) {
        this.currentIndex = index;
        this.stories.forEach((story, i) => {
          story.classList.remove('is-active', 'is-adjacent');
          if (i === index) story.classList.add('is-active');
          else if (i === index - 1 || i === index + 1) story.classList.add('is-adjacent');
        });
        this.stories.forEach((story) => {
          const c = this.getStoryMediaContainer(story);
          if (c) { VSWMedia.unmount(c); VSWMedia.restorePoster(c); }
        });
        const active = this.getStoryMediaContainer(this.stories[index]);
        if (active) {
          VSWMedia.mount(active, {
            autoplay: active.dataset.vscMediaType === 'external_video',
            muted: this.isMuted,
            context: 'modal'
          });
        }
        this.updateProgressUI();
        this.playActiveStory();
      }

      getActiveVideo() {
        const el = VSWMedia.getMediaElement(this.getStoryMediaContainer(this.stories[this.currentIndex]));
        return el?.tagName === 'VIDEO' ? el : null;
      }

      playActiveStory() {
        this.pauseAllStories();
        const container = this.getStoryMediaContainer(this.stories[this.currentIndex]);
        const element = container ? VSWMedia.getMediaElement(container) : null;
        if (!element || element.tagName !== 'VIDEO') {
          this.startFallbackProgress(element?.tagName === 'IFRAME' ? 15000 : 5000);
          return;
        }
        element.currentTime = 0;
        element.muted = this.isMuted;
        const start = () => {
          element.play().catch(() => {});
          element.onended = () => this.next();
          this.trackProgress(element);
        };
        if (element.readyState >= 2) start();
        else element.addEventListener('loadeddata', start, { once: true });
      }

      pauseAllStories() {
        this.stories.forEach((story) => {
          const c = this.getStoryMediaContainer(story);
          if (c) {
            VSWMedia.pause(c);
            c.querySelector('video') && (c.querySelector('video').onended = null);
          }
        });
        cancelAnimationFrame(this.progressRaf);
      }

      trackProgress(video) {
        const fill = this.segments[this.currentIndex]?.querySelector('.video-stories-modal__progress-fill');
        if (!fill) return;
        const update = () => {
          if (!video.duration || Number.isNaN(video.duration)) {
            this.progressRaf = requestAnimationFrame(update);
            return;
          }
          fill.style.width = `${(video.currentTime / video.duration) * 100}%`;
          if (!video.paused && !video.ended) this.progressRaf = requestAnimationFrame(update);
        };
        cancelAnimationFrame(this.progressRaf);
        this.progressRaf = requestAnimationFrame(update);
      }

      startFallbackProgress(duration) {
        const fill = this.segments[this.currentIndex]?.querySelector('.video-stories-modal__progress-fill');
        if (!fill) return;
        const start = performance.now();
        const tick = (now) => {
          const p = Math.min((now - start) / duration, 1);
          fill.style.width = `${p * 100}%`;
          if (p < 1) this.progressRaf = requestAnimationFrame(tick);
          else this.next();
        };
        cancelAnimationFrame(this.progressRaf);
        this.progressRaf = requestAnimationFrame(tick);
      }

      updateProgressUI() {
        this.segments.forEach((segment, i) => {
          const fill = segment.querySelector('.video-stories-modal__progress-fill');
          segment.classList.toggle('is-complete', i < this.currentIndex);
          if (fill) fill.style.width = i < this.currentIndex ? '100%' : '0%';
        });
      }

      syncMuteButtons() {
        this.modal.querySelectorAll('[data-story-mute]').forEach((btn) => {
          btn.classList.toggle('is-muted', this.isMuted);
        });
      }

      toggleMute() {
        this.isMuted = !this.isMuted;
        const video = this.getActiveVideo();
        if (video) video.muted = this.isMuted;
        this.syncMuteButtons();
      }

      destroy() {
        cancelAnimationFrame(this.progressRaf);
      }
    }

    function initVideoStoriesProductWidget(section) {
      if (!section || section.dataset.vswJsReady === 'true') return;
      section._videoStoriesProductWidget?.destroy?.();
      section._videoStoriesProductWidget = new VideoStoriesProductWidget(section);
      section.dataset.vswJsReady = 'true';
    }

    document.querySelectorAll('.video-stories-product-widget[data-section-id]').forEach(initVideoStoriesProductWidget);

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.video-stories-product-widget[data-section-id]');
      if (section) delete section.dataset.vswJsReady;
      initVideoStoriesProductWidget(section);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('.video-stories-product-widget[data-section-id]');
      if (section?._videoStoriesProductWidget?.destroy) {
        section._videoStoriesProductWidget.destroy();
        delete section._videoStoriesProductWidget;
        delete section.dataset.vswJsReady;
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-stories-carousel"] && !Shopify.designMode) return;
  try {
    

  class VideoStoriesCarousel {
    constructor(section) {
      this.section = section;
      this.shuffleStories();
      this.track = section.querySelector('.video-stories-carousel__track');
      this.prevBtn = section.querySelector('.video-stories-carousel__nav--prev');
      this.nextBtn = section.querySelector('.video-stories-carousel__nav--next');
      this.slides = section.querySelectorAll('.video-stories-carousel__slide');
      this.videos = section.querySelectorAll('.video-stories-carousel__video-inner video');
      this.autoplayEnabled = section.dataset.videoAutoplay === 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.modal = section.querySelector('.video-stories-modal');

      if (!this.track || this.slides.length === 0) return;

      this.bindEvents();
      this.updateNavState();
      this.prepareCarouselVideos();

      if (this.autoplayEnabled && !this.reducedMotion) {
        this.initAutoplay();
      }

      if (this.modal) {
        this.storiesModal = new VideoStoriesModal(section, this);
      }
    }

    shuffleStories() {
      const slides = Array.from(this.section.querySelectorAll('.video-stories-carousel__slide'));
      const stories = Array.from(this.section.querySelectorAll('.video-stories-modal__story'));
      const slidesContainer = this.section.querySelector('.video-stories-carousel__slides');
      const storiesContainer = this.section.querySelector('.video-stories-modal__stories');
      if (!slidesContainer || !storiesContainer || slides.length !== stories.length) return;

      const pairs = slides.map((slide, index) => ({ slide, story: stories[index] }));
      for (let i = pairs.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [pairs[i], pairs[j]] = [pairs[j], pairs[i]];
      }

      const limit = Number(this.section.dataset.productsLimit) || pairs.length;
      pairs.forEach(({ slide, story }, index) => {
        if (index >= limit) {
          slide.remove();
          story.remove();
          return;
        }
        slide.dataset.slideIndex = String(index + 1);
        slide.dataset.storyIndex = String(index);
        slide.querySelectorAll('[data-story-open]').forEach((trigger) => {
          trigger.dataset.storyOpen = String(index);
        });
        story.dataset.storyIndex = String(index);
        slidesContainer.append(slide);
        storiesContainer.append(story);
      });
    }

    bindEvents() {
      this.prevBtn?.addEventListener('click', () => this.scroll('prev'));
      this.nextBtn?.addEventListener('click', () => this.scroll('next'));
      this.track.addEventListener('scroll', () => {
        this.updateNavState();
        this.playVisibleCarouselVideos();
      }, { passive: true });
      window.addEventListener('resize', () => {
        this.updateNavState();
        this.playVisibleCarouselVideos();
      }, { passive: true });
    }

    prepareCarouselVideos() {
      this.videos.forEach((video) => {
        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.controls = false;
        video.removeAttribute('controls');
        video.playsInline = true;
        video.disablePictureInPicture = true;
        video.setAttribute('disablepictureinpicture', '');

        video.addEventListener('loadeddata', () => this.playCarouselVideo(video));
        video.addEventListener('canplay', () => this.playCarouselVideo(video));
      });
    }

    playCarouselVideo(video) {
      if (!video || !this.autoplayEnabled) return;
      if (!this.isVideoVisibleInTrack(video)) return;

      video.muted = true;
      video.defaultMuted = true;

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          setTimeout(() => this.playCarouselVideo(video), 300);
        });
      }
    }

    isVideoVisibleInTrack(video) {
      const trackRect = this.track.getBoundingClientRect();
      const videoRect = video.getBoundingClientRect();
      return videoRect.right > trackRect.left + 4 && videoRect.left < trackRect.right - 4;
    }

    playVisibleCarouselVideos() {
      if (!this.autoplayEnabled || this.reducedMotion) return;

      this.videos.forEach((video) => {
        if (this.isVideoVisibleInTrack(video)) {
          this.playCarouselVideo(video);
        } else {
          video.pause();
        }
      });
    }

    initAutoplay() {
      this.playVisibleCarouselVideos();

      requestAnimationFrame(() => this.playVisibleCarouselVideos());
      setTimeout(() => this.playVisibleCarouselVideos(), 100);
      setTimeout(() => this.playVisibleCarouselVideos(), 500);
      setTimeout(() => this.playVisibleCarouselVideos(), 1500);

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting) {
                this.playCarouselVideo(video);
              } else {
                video.pause();
              }
            });
          },
          { root: this.track, threshold: 0.25 }
        );

        this.videos.forEach((video) => observer.observe(video));
      }
    }

    getScrollAmount() {
      const slide = this.slides[0];
      if (!slide) return 0;
      const gap = parseFloat(getComputedStyle(this.section).getPropertyValue('--vsc-gap')) || 16;
      return slide.offsetWidth + gap;
    }

    scroll(direction) {
      const amount = this.getScrollAmount();
      this.track.scrollBy({
        left: direction === 'next' ? amount : -amount,
        behavior: this.reducedMotion ? 'auto' : 'smooth'
      });
    }

    updateNavState() {
      if (!this.prevBtn || !this.nextBtn) return;

      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const tolerance = 2;

      this.prevBtn.disabled = this.track.scrollLeft <= tolerance;
      this.nextBtn.disabled = this.track.scrollLeft >= maxScroll - tolerance;
    }

  }

  class VideoStoriesModal {
    constructor(section, carousel) {
      this.section = section;
      this.carousel = carousel;
      this.modal = section.querySelector('.video-stories-modal');
      this.stories = Array.from(section.querySelectorAll('.video-stories-modal__story'));
      this.progressEl = section.querySelector('[data-story-progress]');
      this.currentIndex = 0;
      this.progressRaf = null;

      if (!this.modal || this.stories.length === 0) return;

      this.buildProgress();
      this.bindEvents();
    }

    bindEvents() {
      this.section.querySelectorAll('[data-story-open]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          const index = parseInt(trigger.dataset.storyOpen, 10);
          this.open(index);
        });
      });

      this.modal.querySelectorAll('[data-story-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });

      this.modal.querySelectorAll('[data-story-prev]').forEach((el) => {
        el.addEventListener('click', () => this.prev());
      });

      this.modal.querySelectorAll('[data-story-next]').forEach((el) => {
        el.addEventListener('click', () => this.next());
      });

      document.addEventListener('keydown', (event) => {
        if (!this.modal.classList.contains('is-open')) return;
        if (event.key === 'Escape') this.close();
        if (event.key === 'ArrowLeft') this.prev();
        if (event.key === 'ArrowRight') this.next();
      });
    }

    buildProgress() {
      if (!this.progressEl) return;
      this.progressEl.innerHTML = '';
      this.stories.forEach((_, index) => {
        const segment = document.createElement('div');
        segment.className = 'video-stories-modal__progress-segment';
        segment.dataset.segmentIndex = index;
        const fill = document.createElement('span');
        fill.className = 'video-stories-modal__progress-fill';
        segment.appendChild(fill);
        this.progressEl.appendChild(segment);
      });
      this.segments = Array.from(this.progressEl.querySelectorAll('.video-stories-modal__progress-segment'));
    }

    open(index) {
      this.currentIndex = Math.max(0, Math.min(index, this.stories.length - 1));
      this.modal.hidden = false;
      this.modal.classList.add('is-open');
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('video-stories-modal-open');
      this.carousel.videos.forEach((video) => video.pause());
      this.showStory(this.currentIndex);
    }

    close() {
      this.modal.classList.remove('is-open');
      this.modal.hidden = true;
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('video-stories-modal-open');
      this.pauseAllStories();
      cancelAnimationFrame(this.progressRaf);
      this.carousel.playVisibleCarouselVideos();
    }

    prev() {
      if (this.currentIndex > 0) {
        this.showStory(this.currentIndex - 1);
      } else {
        this.close();
      }
    }

    next() {
      if (this.currentIndex < this.stories.length - 1) {
        this.showStory(this.currentIndex + 1);
      } else {
        this.close();
      }
    }

    showStory(index) {
      this.currentIndex = index;
      this.stories.forEach((story, i) => {
        story.classList.remove('is-active', 'is-adjacent');
        if (i === index) {
          story.classList.add('is-active');
        } else if (i === index - 1 || i === index + 1) {
          story.classList.add('is-adjacent');
        }
      });
      this.updateProgressUI();
      this.playActiveStory();
    }

    getActiveVideo() {
      const story = this.stories[this.currentIndex];
      return story?.querySelector('.video-stories-modal__video') || null;
    }

    playActiveStory() {
      this.pauseAllStories();
      const video = this.getActiveVideo();
      if (!video) {
        this.startFallbackProgress(5000);
        return;
      }

      video.currentTime = 0;
      video.muted = true;
      video.play().catch(() => {});
      video.onended = () => this.next();
      this.trackProgress(video);
    }

    pauseAllStories() {
      this.stories.forEach((story) => {
        const video = story.querySelector('.video-stories-modal__video');
        if (video) {
          video.pause();
          video.onended = null;
        }
      });
      cancelAnimationFrame(this.progressRaf);
    }

    trackProgress(video) {
      const segment = this.segments[this.currentIndex];
      const fill = segment?.querySelector('.video-stories-modal__progress-fill');
      if (!fill) return;

      const update = () => {
        if (!video.duration || Number.isNaN(video.duration)) {
          this.progressRaf = requestAnimationFrame(update);
          return;
        }
        fill.style.width = `${(video.currentTime / video.duration) * 100}%`;
        if (!video.paused && !video.ended) {
          this.progressRaf = requestAnimationFrame(update);
        }
      };

      cancelAnimationFrame(this.progressRaf);
      this.progressRaf = requestAnimationFrame(update);
    }

    startFallbackProgress(duration) {
      const segment = this.segments[this.currentIndex];
      const fill = segment?.querySelector('.video-stories-modal__progress-fill');
      if (!fill) return;

      const start = performance.now();
      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        fill.style.width = `${progress * 100}%`;
        if (progress < 1) {
          this.progressRaf = requestAnimationFrame(tick);
        } else {
          this.next();
        }
      };

      cancelAnimationFrame(this.progressRaf);
      this.progressRaf = requestAnimationFrame(tick);
    }

    updateProgressUI() {
      this.segments.forEach((segment, i) => {
        const fill = segment.querySelector('.video-stories-modal__progress-fill');
        segment.classList.toggle('is-complete', i < this.currentIndex);
        if (fill) fill.style.width = i < this.currentIndex ? '100%' : '0%';
      });
    }

  }

  function initVideoStoriesCarousels() {
    document.querySelectorAll('.video-stories-carousel[data-section-id]').forEach((section) => {
      section._videoStoriesCarousel = new VideoStoriesCarousel(section);
    });
  }

  initVideoStoriesCarousels();

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.video-stories-carousel[data-section-id]');
    if (section) {
      section._videoStoriesCarousel = new VideoStoriesCarousel(section);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
